<template>
  <div class="shopping-play-box">
    <div class="shopping-play-content">
      <div class="shopping-play-header">
        <p>续订Mind+</p>
        <a-icon type="close" class="icon-shopping-play" @click="HideShoppingPlayModel" />
      </div>
      <div class="shopping-play-code">
        <h3>上海市玉树科技有限公司</h3>
        <p>订单号：1804883620200915135019705</p>
        <div class="code-img-view">
            <img src="data:image/png;base64,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" alt="">
        </div>
        <div class="money-price">
          <span>价格：</span>
          <span class="money">￥198</span>
        </div>
      </div>
      <div class="play-mode-box">
          <div class="play-mode">
              支付方式：
          </div>
          <div class="wx-play">
              <a-icon type="wechat" class="wx-icon"/>
              <span>微信支付</span>
          </div>
          <div class="ali-play">
              <a-icon type="alipay-circle" class="ali-icon"/>
              <span>支付宝支付</span>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted(){
      
  },
  methods:{
    //是否显示
    HideShoppingPlayModel(){
      this.$emit('HideShoppingPlayModel',false)
    }
  }
};
</script>
<style scoped>
.shopping-play-box {
  margin: 0 auto;
  position: relative;
  display: flex;
  justify-content: center;
}
.shopping-play-content {
  border: 1px solid rgb(218, 218, 218);
  border-radius: 5px;
  width: 500px;
  height: 400px;
  background-color: #ffffff;
  position: absolute;
  top: 50px;
  z-index: 9999;
}
.shopping-play-header {
  border-bottom: 1px solid rgb(218, 218, 218);
  height: 43px;
}
.shopping-play-header p {
  padding: 10px;
}
.icon-shopping-play {
  position: absolute;
  right: 10px;
  top: 15px;
}
.shopping-play-code {
  text-align: center;
}
.shopping-play-code h3{
    margin-top: 20px;
}
.money-price{
    margin-top: 20px;
}
.money-price .money{
    color: #fb3848; 
    font-size: 16px;
}
.play-mode-box {
    padding: 20px;
    margin: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.play-mode{
    line-height: 35px;
}
.wx-icon{
    font-size: 22px;
    color: green;
}
.ali-icon{
    font-size: 22px;
    color: skyblue;
}
.wx-play{
    border: 1px solid rgb(218, 218, 218);
    text-align: center;
    height: 35px;
    width: 150px;
    border-radius: 5px;
}
.wx-play:hover{
    border: 1px solid rgb(218, 218, 218);
    text-align: center;
    height: 35px;
    width: 150px;
    border-radius: 5px;
    /* background-color: #fb3848; */
}
.wx-play span{
    line-height: 35px
}
.ali-play{
    border: 1px solid rgb(218, 218, 218);
    text-align: center;
    height: 35px;
    width: 150px;
    border-radius: 5px;
}
.ali-play:hover{
    border: 1px solid rgb(218, 218, 218);
    text-align: center;
    height: 35px;
    width: 150px;
    border-radius: 5px;
    /* background-color: #fb3848; */
}
.ali-play span{
    line-height: 35px
}
.icon-shopping-play{
  transition: .3s;
}
.icon-shopping-play:hover{
  transition: .3s;
  color: red;
  transform: rotate(180deg);
}
</style>